"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <html lang="fr">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          background: "#ffffff",
          color: "#0f172a",
          padding: "24px",
        }}
      >
        <div style={{ maxWidth: 360, width: "100%", textAlign: "center" }}>
          <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 8 }}>
            Une erreur inattendue est survenue
          </h1>
          <p style={{ fontSize: 14, color: "#475569", marginBottom: 24 }}>
            Veuillez rafraîchir la page pour réessayer.
          </p>
          <button
            onClick={() => reset()}
            style={{
              height: 44,
              padding: "0 24px",
              borderRadius: 8,
              border: "none",
              background: "#1E6DFF",
              color: "#ffffff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              width: "100%",
            }}
          >
            Recharger la page
          </button>
        </div>
      </body>
    </html>
  );
}
